import request from '@/utils/request'
import { AppFieldDTO, AppStepSectionDTO, SelectItem, SelectItemList } from './types-app'

const CONTENT_ROUTE = 'api/v1/content/'

export const getOrderDataTree = async(orderId, productGroup) =>
  request({
    url: CONTENT_ROUTE + `structure/menu/${orderId}/${productGroup}`,
    method: 'get'
  })

export const getEditableForm = async(editablePageURL) =>
  request({
    url: `api/v1/${editablePageURL}`,
    method: 'get'
  })
